import { useContext } from 'react';
import { MobileCheckContext } from "../context/MobileCheckContext.js";
import { SettingsContext } from "../context/SettingsContext.js";
export function useMobileCheck() {
  const {
    externalSearch
  } = useContext(SettingsContext);
  return useContext(MobileCheckContext).isMobile && !externalSearch;
}